module.exports = __webpack_public_path__ + "img/market7.f1b1a6f5.svg";